import i18n from 'src/lib/i18n/i18n';
import View from '@play-co/timestep-core/lib/ui/View';
import PopupBasic from '../../components/popups/PopupBasic';
import ButtonScaleViewWithText, {
  Opts,
} from 'src/lib/ui/components/ButtonScaleViewWithText';
import { Feature } from 'src/replicant/analytics';
import sounds from 'src/lib/sounds';
import uiConfig from 'src/lib/ui/config';
import { LangBitmapOpts } from '../../../lib/ui/components/LangBitmapFontTextView';

import { AssetGroup } from '@play-co/timestep-core';

namespace style {
  export const popup = {
    height: 400,
    zIndex: 10000,
  };

  export const message: LangBitmapOpts = {
    y: 100,
    height: 142,
    verticalAlign: 'center',
  };

  export const okButton: Omit<Opts, 'tracking'> = {
    ...uiConfig.buruburu.care.confirmation.okButton,
  };
  okButton.y = popup.height - okButton.height! - 40;

  export const cancelButton: Omit<Opts, 'tracking'> = {
    ...uiConfig.buruburu.care.confirmation.backButton,
  };
  cancelButton.y = popup.height - cancelButton.height! - 40;
}

export default class PopupNativeLineGuestLogin extends PopupBasic {
  constructor(opts: { superview: View; close: (success?: boolean) => void }) {
    super({
      ...style.popup,
      ...opts,
      tracking: {
        feature: Feature.NATIVE._,
        $subFeature: Feature.NATIVE.LINE_GUEST_LOGIN,
      },
    });

    this.buttonClose.removeFromSuperview();

    this.message.updateOpts(style.message);

    this.box.addSubview(
      new ButtonScaleViewWithText({
        ...style.cancelButton,
        localeText: () => i18n('native.guest.loginLine.close'),
        tracking: {
          feature: Feature.NATIVE._,
          $subFeature: Feature.NATIVE.LINE_GUEST_LOGIN_CLOSE,
        },
        onClick: async () => {
          sounds.sfx.play('cancel');
          opts.close(false);
        },
      }),
    );

    this.box.addSubview(
      new ButtonScaleViewWithText({
        ...style.okButton,
        localeText: () => i18n('native.guest.loginLine.cta'),
        tracking: {
          feature: Feature.NATIVE._,
          $subFeature: Feature.NATIVE.LINE_GUEST_LOGIN_OK,
        },
        onClick: async () => {
          sounds.sfx.play('ok');
          opts.close(true);
        },
      }),
    );
  }

  protected getAssetsGroup() {
    return new AssetGroup([]);
  }

  public init(opts: { originFeature: 'sequence' | 'feature' }) {
    super.init({
      title: i18n(`native.guest.loginLine.${opts.originFeature}.title`),
      message: i18n(`native.guest.loginLine.${opts.originFeature}.message`),
    });
  }
}
